import React from 'react'

import {
  B4,
  B5,
  BTN_LG,
  BTN_SM,
  H6,
  Icon,
  SH3,
  Stack,
  XStack,
  colors,
} from '@zet/design-system'
import { Alert } from '@zet/design-system/alert'
import Pressable from '@zet/design-system/pressable'
import { currencyFormatConvertor } from '@zet/utils/stringConversion'

import Currency from '../../assets/currencyNotes.svg'
import { i18n } from '../../localization'

type Props = {
  amount: any
  showWarning?: boolean | undefined
  showAccountButton?: boolean | undefined
  accountButtonText?: string | undefined
  title?: string | undefined
  viewAllButtonAction: () => void
  accountButtonAction?: () => void
}
const TeamEarningsWidget = (props: Props) => {
  const {
    amount,
    showWarning = false,
    showAccountButton = false,
    accountButtonText = 'Add Account',
    title = i18n.t('earningsWidget.earningsFromMyTeam'),
    viewAllButtonAction = () => null,
    accountButtonAction = () => null,
  } = props
  return (
    <Stack className="mb-1 bg-white px-3 pb-3 pt-3.5">
      {/* Header */}
      <XStack className="items-center">
        <Stack>
          <Currency />
        </Stack>
        <Stack className="ml-2.5">
          <SH3>{title}</SH3>
        </Stack>
      </XStack>
      {/* Earnings amount and View all */}
      <Stack className="bg-grays-20 border-grays-30 mt-3 rounded border px-3.5 py-3">
        <XStack className="items-center justify-between">
          <Stack>
            <H6>₹{currencyFormatConvertor(amount) || 0}</H6>
            <B4 className="text-grays-70">
              {i18n.t('earningsWidget.totalEarning')}
            </B4>
          </Stack>
          <Stack>
            <Pressable onPress={viewAllButtonAction} className="px-2">
              <BTN_SM className="text-primary-100">
                {i18n.t('earningsWidget.viewAll')}
              </BTN_SM>
            </Pressable>
          </Stack>
        </XStack>
      </Stack>
      {/* Add bank account details */}
      {showWarning ? (
        <Alert
          intent={'warning'}
          iconLeft={{
            name: 'CautionOutlined',
            color: colors.warning[150],
          }}
          className="mt-3.5"
        >
          <B5 className={'text-warning-200'}>
            {i18n.t('earningsWidget.addBankAccountWarning')}
          </B5>
        </Alert>
      ) : (
        <></>
      )}
      {/* Add account button with text as props */}
      {showWarning || showAccountButton ? (
        <Pressable
          onPress={accountButtonAction}
          className="border-primary-100 mt-3 items-center justify-center rounded border px-4 py-2"
        >
          <XStack className="items-center">
            <Icon type={'BankOutlined'} color={colors.primary[100]} size={24} />
            <BTN_LG className="text-primary-100 ml-2">
              {accountButtonText}
            </BTN_LG>
          </XStack>
        </Pressable>
      ) : (
        <></>
      )}
    </Stack>
  )
}

export { TeamEarningsWidget }
